var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcSelfTaught(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1053",
    "data-name": "Rectangle 1053",
    width: 28.861,
    height: 34.687,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic_self_taught",
    transform: "translate(-328.833 -215.421)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_49",
    "data-name": "Ellipse 49",
    cx: 25,
    cy: 25,
    r: 25,
    transform: "translate(328.833 215.421)",
    fill: "rgba(195,230,255,0)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_186",
    "data-name": "Group 186",
    transform: "translate(339.403 223.078)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_186-2",
    "data-name": "Group 186",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_21782",
    "data-name": "Path 21782",
    d: "M13.224,14.819c-2.691-3.232-3.67-2.063-7-2.894C2.546,11,1.746,8.893,2.821,6.471S5.99.759,11.994,1.064c5.621.287,8.859,4.223,7.917,7.322s-6.85,3.742-5.3,6.971Z",
    transform: "translate(4.809 2.11)",
    fill: "#e08c35"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21783",
    "data-name": "Path 21783",
    d: "M3.329,9.523c.3.109.622.211.979.3,3.329.831,4.307-.335,7,2.894l1.386.538c-1.55-3.229,4.359-3.875,5.3-6.971A4.107,4.107,0,0,0,17.8,3.507,9.682,9.682,0,0,0,3.329,9.523",
    transform: "translate(6.726 4.21)",
    fill: "#d84f45"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21784",
    "data-name": "Path 21784",
    d: "M9.422,33.462l.009-.746c.042-2.688-.29-4.818-.915-5.839-.284-.468-1.661-1.012-4.6-1.012-.489,0-.813.015-.822.015l-.707.039-.314-3.443,0,0v-.039l-.009-.088.012-.006.088-3.2c-.35-.03-.773-.063-1.09-.063a.8.8,0,0,1-.713-.411c-.293-.526,0-1,.864-2.4.951-1.54,2.546-4.117,2.586-5.95C3.877,6.936,7.637.491,14.575.258c.263-.009.523-.015.779-.015C24.41.243,27.636,5.852,27.636,11.1a16.194,16.194,0,0,1-3.7,10.409c-1.2,1.685-2.154,3.014-2.154,4.848v7.11ZM15.569,3.1c-5.029,0-6.968,2.842-8.2,5.621a3.146,3.146,0,0,0-.169,2.7c.447.915,1.543,1.6,3.259,2.027a15.182,15.182,0,0,0,2.462.381c1.8.163,3.1.281,5.292,2.909a5.8,5.8,0,0,1,1.414,3.371,5.507,5.507,0,0,0-.513-2.018c-1.2-2.5.74-3.93,2.3-5.077a6.269,6.269,0,0,0,2.573-2.794,4.314,4.314,0,0,0-.813-3.667,8.9,8.9,0,0,0-6.9-3.437c-.239-.012-.474-.018-.7-.018",
    transform: "translate(0.494 0.49)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21785",
    "data-name": "Path 21785",
    d: "M15.846,0c-.263,0-.532.006-.8.015C8.171.245,3.652,6.557,3.564,10.8,3.525,12.432,2,14.9,1.088,16.38S-.3,18.618.206,19.518a1.547,1.547,0,0,0,1.353.788c.1,0,.217,0,.338.009l-.054,2.027-.069.03.051.58-.015.565.069.018.2,2.238.127,1.411,1.417-.079c.018,0,.323-.018.782-.018,2.761,0,3.833.507,3.99.683.529.873.834,2.912.794,5.428l-.024,1.489h13.84V26.843c0-1.6.888-2.842,2.018-4.419,1.71-2.4,3.836-5.373,3.836-10.837C28.861,5.987,25.442,0,15.846,0m5.691,26.843v6.376H18.063a19.643,19.643,0,0,1-.069-2.045c.072-3.126.924-3.483,1.984-6.1,1.03-2.534,1.205-4.881.284-6.8-1.631-3.4,3.924-4.081,4.914-7.34S22.717,3.181,16.8,2.879c-.254-.012-.5-.018-.74-.018-5.751,0-7.787,3.609-8.874,6.056-1.133,2.552-.287,4.775,3.582,5.742,3.507.873,4.537-.353,7.37,3.048s.112,7.152-.882,9.986a14.661,14.661,0,0,0-.477,5.527H10.659c.021-1.5-.048-4.633-1.021-6.234C8.9,25.777,5.905,25.62,4.407,25.62c-.523,0-.864.021-.864.021L3.332,23.3l1.238-.532-1.263-.356L3.4,18.981s-1.133-.142-1.842-.142,3.4-4.748,3.474-8S8.79,1.694,15.09,1.483c.257-.009.51-.012.755-.012,8.116,0,11.547,4.615,11.547,10.116,0,8.717-5.857,10.415-5.857,15.256m-2.888-10.78A6.754,6.754,0,0,0,13.475,13.6a14.47,14.47,0,0,1-2.35-.362C9.651,12.864,8.69,12.3,8.349,11.6A2.46,2.46,0,0,1,8.53,9.515c1.2-2.694,2.933-5.186,7.53-5.186.217,0,.438.006.665.018a8.166,8.166,0,0,1,6.334,3.126,3.6,3.6,0,0,1,.713,3.03,5.725,5.725,0,0,1-2.308,2.416,7.135,7.135,0,0,0-2.815,3.144",
    transform: "translate(0 -0.001)",
    fill: "#404040"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSelfTaught);
export default __webpack_public_path__ + "static/media/ic_self_taught.cef70d4cd3337c845e8f993e5877b603.svg";
export { ForwardRef as ReactComponent };